import React from "react";

const LoadingButton = ({
  text,
  loading = false,
  type = "button",
  onClick,
  style = {},
  disabled = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={loading || disabled}
      style={{
        backgroundColor: loading ? "#9ca3af" : "#2563eb", // gray / blue
        color: "#fff",
        padding: "10px 16px",
        border: "none",
        borderRadius: "6px",
        cursor: loading ? "not-allowed" : "pointer",
        opacity: loading ? 0.8 : 1,
        ...style,
      }}
    >
      {loading ? "Please wait..." : text}
    </button>
  );
};

export default LoadingButton;
